import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';
import React from 'react';
import { ELIGIBLE_CITIES_FOR_SEASONAL_MODULE } from '../../pages/categoryBrowse/constants/seasonal';
import './SeasonalRibbon.scss';

export const SeasonalRibbon = (props: {
    locationSlug: string;
    placeId: string;
    country: string;
    browseSurface?: string;
}) => {
    const { locationSlug, placeId, country, browseSurface } = props;

    const ctaLink = `/b/${locationSlug}/seasonal`;
    const ribbonTitle = gettext("St. Patrick's Day is here \u{1F340}");
    const ribbonCtaText = gettext('Explore events');

    const isGeoEligibleForSeasonalRibbon =
        country === 'United States' ||
        country === 'USA' ||
        Object.hasOwnProperty.call(
            ELIGIBLE_CITIES_FOR_SEASONAL_MODULE,
            placeId,
        );

    if (!isGeoEligibleForSeasonalRibbon) {
        return null;
    }

    return (
        <div className="seasonal-ribbon">
            <div className="seasonal-ribbon-container">
                <div
                    className="seasonal-ribbon-title-container"
                    data-testid="seasonal-ribbon-title"
                >
                    <h2 className="eds-text-bm">{ribbonTitle}</h2>
                </div>
                <div className="seasonal-ribbon-cta">
                    <a
                        href={ctaLink || ''}
                        data-heap-id={`seasonal_ribbon_click_${browseSurface}`}
                    >
                        <Button className="seasonal-ribbon-button">
                            <span className="eds-text-bm">{ribbonCtaText}</span>
                        </Button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default SeasonalRibbon;
